const TransmissionTypes = [
  { label: 'Automatic', value: 'automatic' },
  { label: 'Manual', value: 'manual' },
  { label: 'Semi-Auto', value: 'semi-auto' },
]

export default TransmissionTypes
